import moment from "moment";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { getType } from "typesafe-actions";
import { createDayActions, dayActions, daysActions, updateDayActions } from "./hours.actions";
import { createDayApi, getDayApi, getDaysApi, updateDayApi } from "./hours.api";
import { HoursDto } from "./hours.dtos";

function* setDays(result: HoursDto[], newItems: HoursDto[]) {
    result.forEach(i => {
      let oldItemIndex = newItems.findIndex(s => s.id === i.id);
      if (oldItemIndex === -1) newItems.push(i);
      else newItems[oldItemIndex] = i;
    }); 

    yield put({ type: getType(daysActions.success), payload: newItems });
    sessionStorage.setItem(`days`, JSON.stringify(newItems));
}

function* handleGetDays(request: ReturnType<typeof daysActions.request>) {
    const storeList: HoursDto[] = yield select(state => state.days.list);
    const dayStorage = sessionStorage.getItem(`days`);
    const sessionDays = dayStorage === null ? [] : JSON.parse(dayStorage) as HoursDto[];
    const days: HoursDto[] = 
    // storeList !== undefined && storeList.length !== 0 ? storeList :
    //   sessionDays.length !== 0 ? sessionDays :
        yield call(getDaysApi);
  
    yield put({ type: getType(daysActions.success), payload: days });
    sessionStorage.setItem(`days`, JSON.stringify(days));
}

function* handleGetDay(request: ReturnType<typeof dayActions.request>) {
    const storeDay: HoursDto = yield select(state => state.days.day);
    const day: HoursDto = (storeDay !== undefined && storeDay.id !== undefined && storeDay.id === request.payload) ? storeDay : yield call(getDayApi, request.payload);
  
    yield put({ type: getType(dayActions.success), payload: day });
  }

function* handleUpdateDay(request: ReturnType<typeof updateDayActions.request>) {
    const storeList = yield select(state => state.days.list);
    const updatedDay: HoursDto = yield call(updateDayApi, request.payload);
  
    yield put({ type: getType(dayActions.success), payload: updatedDay });
  
    if (storeList !== undefined && storeList.length !== 0)
      yield setDays([updatedDay], JSON.parse(JSON.stringify(storeList)) as HoursDto[]);
}
  
function* handleCreateDay(request: ReturnType<typeof createDayActions.request>) {
    const storeList = yield select(state => state.days.list);
    const createdDay: HoursDto = yield call(createDayApi, request.payload);
  
    yield put({ type: getType(dayActions.success), payload: createdDay });
  
    if (storeList !== undefined && storeList.length !== 0)
      yield setDays([createdDay], JSON.parse(JSON.stringify(storeList)) as HoursDto[]);
}

export function* watchGetDaysRequest() {
  try {
    yield takeLatest(getType(daysActions.request), handleGetDays);
  }
  catch (err) {
    console.log(err);
  }
}

export function* watchGetDayRequest() {
  try {
    yield takeLatest(getType(dayActions.request), handleGetDay);
  }
  catch (err) {
    console.log(err);
  }
}

export function* watchUpdateDayRequest() {
  try {
    yield takeLatest(getType(updateDayActions.request), handleUpdateDay);
  }
  catch (err) {
    console.log(err);
  }
}

export function* watchCreateDayRequest() {
  try {
    yield takeLatest(getType(createDayActions.request), handleCreateDay);
  }
  catch (err) {
    console.log(err);
  }
}